import {Box, Chip, IconButton, Typography} from "@mui/material";
import {getRandomColor, truncateText} from "../../helpers/Utils";
import {useState} from "react";
import DeleteIcon from "@mui/icons-material/Delete";

const NewsItemComponent: React.FC<{ index, news, onDelete, onClick }> = ({index, news, onDelete, onClick}) => {
    const [hovered, setHovered] = useState(false);
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                gap: 2,
            }}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                    }}
                    onClick={() => onClick(news)}
                >
                    <Typography variant="body1">{index + 1}</Typography>
                    {<news.newsTypeIcon/>}
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        gap: 2,
                    }}
                    onClick={() => onClick(news)}
                >
                    <Typography variant="body2">
                        {news.title
                            ? truncateText(news.title, 20)
                            : truncateText(news.content, 20)}
                    </Typography>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 2,
                            }}
                        >
                            {news.hashtag && (<Chip
                                label={news.hashtag}
                                size="small"
                                sx={{
                                    backgroundColor: "#3b3b3b",
                                    color: getRandomColor(),
                                    fontWeight: "bold",
                                }}
                            /> )}
                            {news.provider && (
                                <Chip
                                    label={news.provider}
                                    size="small"
                                    sx={{
                                        backgroundColor: "#3b3b3b",
                                        color: getRandomColor(),
                                        fontWeight: "bold",
                                    }}
                                />
                            )}
                        </Box>

                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 2,
                            }}
                        >
                            {news.location_name && (
                                <Typography
                                    variant="caption"
                                    sx={{
                                        color: "gray",
                                        marginRight: "10px",
                                    }}
                                >
                                    {news.location_name}
                                </Typography>
                            )}
                            {news.time && (
                                <Typography
                                    variant="caption"
                                    sx={{
                                        color: "gray",
                                        marginRight: "10px",
                                    }}
                                >
                                    {news.time}
                                </Typography>
                            )}
                        </Box>
                    </Box>
                </Box>
                {hovered && (
                    <IconButton
                        onClick={() => onDelete(news.id)}
                        style={{
                            right: "8px",
                            backgroundColor: "rgba(255, 255, 255, 0.8)",
                        }}
                    >
                        <DeleteIcon sx={{fontSize: 20}}/>
                    </IconButton>
                )}
            </Box>
        </Box>
    );
};

export default NewsItemComponent;